import { render, staticRenderFns } from "./PermissionsModal.vue?vue&type=template&id=28b38329"
import script from "./PermissionsModal.vue?vue&type=script&lang=js"
export * from "./PermissionsModal.vue?vue&type=script&lang=js"
import style0 from "./PermissionsModal.vue?vue&type=style&index=0&id=28b38329&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports